import Carousel from "react-material-ui-carousel";
import BannerItem from "./banner_item/BannerItem";
import hotDealsImgBanner from "../../images/best-selling-image.jpg";
import promoCodesImgBanner from "../../images/hot-deals-image.jpg";
import hotDealsIconBanner from "../../images/hot-deals-colored-icon.svg";
import promoCodesIconBanner from "../../images/promo-codes-colored-icon.svg";

function Banner() {
  const banner_data = [
    {
      bannerImg: hotDealsImgBanner,
      bannerIcon: hotDealsIconBanner,
      bannerTitle: "HOT DEALS",
      bannerSubtitle: "Check out the hottest deals COSMOS has to offer!",
      bannerLink: "/hotdeals",
      buttonText: "Show products",
    },
    {
      bannerImg: promoCodesImgBanner,
      bannerIcon: promoCodesIconBanner,
      bannerTitle: "PROMO CODES",
      bannerSubtitle:
        "Check out the discounts COSMOS can offer, through different coupon codes!",
      bannerLink: "/promocodes",
      buttonText: "Show products",
    },
  ];

  return (
    <Carousel
      navButtonsAlwaysInvisible
      interval={8000}
      timeout={1000}
      animation="fade"
    >
      {banner_data.map((bannerItem, i) => (
        <BannerItem key={i} item={bannerItem} />
      ))}
    </Carousel>
  );
}

export default Banner;
